import {push} from 'react-router-redux'
import {USER_PROFILE, TRANSACTIONS} from '../../../endpoints'
import {apiExternal, apiPrivate} from '../../../api'
import types from '../types/payment'
import depositActions from './orchestrator'
import simpleSnackbarActions from '../../../common/actions/simpleSnackbar'
import {endpoint as endpointText} from '../../../common/text'
import {paymentMethod as text} from '../text'
import Payment from 'payment'
import {User} from '../../../state/actions'
import loginActions from '../../login/actions/login'
import config from '../../../config'

export default class paymentMethod {

  static setTab(tab) {
    return {
      type: types.SET_TAB,
      payload: {
        tab,
      },
    }
  }

  static setSelected(selected) {
    return {
      type: types.SET_SELECTED,
      payload: {
        selected,
      },
    }
  }

  static setNumber(value) {
    return {
      type: types.SET_NUMBER,
      payload: {
        value,
      },
    }
  }

  static setExpiry(value) {
    return {
      type: types.SET_EXPIRY,
      payload: {
        value,
      },
    }
  }

  static setCVC(value) {
    return {
      type: types.SET_CVC,
      payload: {
        value,
      },
    }
  }

  static setCardholderName(value) {
    return {
      type: types.SET_CARDHOLDER_NAME,
      payload: {
        value,
      },
    }
  }

  static saveAdd(type) {
    return function(dispatch, getState) {

      const state = getState().ui.deposit.paymentMethod

      const number = state.getIn(['add', 'number'])
      const expiry = state.getIn(['add', 'expiry'])
      const cvc = state.getIn(['add', 'cvc'])
      const cardholderName = state.getIn(['add', 'cardholderName'])

      if (Payment.fns.validateCardNumber(number) === false) {
        return dispatch(paymentMethod.saveAddFail(text.actions.numberInvalid))
      }
      if (Payment.fns.validateCardExpiry(expiry) === false) {
        return dispatch(paymentMethod.saveAddFail(text.actions.expiryInvalid))
      }
      if (Payment.fns.validateCardCVC(cvc, Payment.fns.cardType(number)) === false) {
        return dispatch(paymentMethod.saveAddFail(text.actions.cvcInvalid))
      }

      dispatch({type: types.SAVE})

      const split = expiry.split(' / ')
      const month = split[0]
      const year = split[1]

      createMPCardToken(number, month, year, cvc, cardholderName)
        .then(cardToken => {

          const data = new FormData()
          data.append('token', cardToken)
          data.append('payment_method', translateType(type))

          apiPrivate.post(USER_PROFILE + '/user/cards', data)
            .then(response => {
              const newCard = response.data.description
              dispatch(paymentMethod.saveAddSuccess(newCard.ID, newCard.Main, newCard.LastDigits, newCard.Type, newCard.TypePhoto))
              dispatch(paymentMethod.setSelected(newCard.ID))
              dispatch(paymentMethod.modifyTransaction())
            }, error => {
              let message = ''
              if (error.response) {
                if (error.response.status === 401) {
                  dispatch(push('/'))
                  dispatch(loginActions.open())
                  dispatch(User.logOut())
                  dispatch(paymentMethod.saveAddFail(message))
                  return
                }
                message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
              } else if (error.request) {
                message = endpointText.internetMayBeTheProblem
              } else {
                message = endpointText.somethingWentWrong
              }
              dispatch(paymentMethod.saveAddFail(message))
              dispatch(simpleSnackbarActions.showMessage(message))
            })

        }, error => {
          dispatch(paymentMethod.saveAddFail(error.response.data))
        })
    }
  }

  static saveAddSuccess(id, main, lastDigits, type, typePhoto) {
    return {
      type: types.SAVE_SUCCESS,
      payload: {
        card: {
          ID: id,
          Main: main,
          LastDigits: lastDigits,
          Type: type,
          TypePhoto: typePhoto,
        },
      },
    }
  }

  static saveAddFail(error) {
    return {
      type: types.SAVE_FAIL,
      payload: {
        error,
      },
    }
  }

  static fetch() {
    return function(dispatch) {

      dispatch({type: types.FETCH})

      apiPrivate.get(USER_PROFILE + '/user/cards')
        .then(response => {
          const data = response.data.description
          dispatch(paymentMethod.fetchSuccess(data))
        }, error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch(paymentMethod.fetchFail(message))
              return
            }
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(paymentMethod.fetchFail(message))
          dispatch(simpleSnackbarActions.showMessage(message))
        })
    }
  }

  static fetchSuccess(data) {
    return {
      type: types.FETCH_SUCCESS,
      payload: {
        cards: data,
      },
    }
  }

  static fetchFail(error) {
    return {
      type: types.FETCH_FAIL,
      payload: {
        error,
      },
    }
  }

  static modifyTransaction() {
    return function(dispatch, getState) {

      const state = getState().ui.deposit.paymentMethod

      const transaction = getState().ui.deposit.start.getIn(['transaction', 'ID'])
      const selected = state.get('selected')
      const selectedCard = state.get('cards').find(a => {
        console.log(a)
        return a.ID === selected
      })

      if (selected === 0)
        return dispatch(paymentMethod.modifyTransactionFail(''))

      dispatch({type: types.MODIFY_TRANSACTION})

      const data = new FormData()
      data.append('card_id', selected)

      apiPrivate.put(TRANSACTIONS + '/transactions/' + transaction, data)
        .then(response => {
          dispatch(paymentMethod.modifyTransactionSuccess(selectedCard))
          dispatch(depositActions.nextStepFromCard())
        }, error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch(paymentMethod.modifyTransactionFail(message))
              return
            }
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(paymentMethod.modifyTransactionFail(message))
          dispatch(simpleSnackbarActions.showMessage(message))
        })
    }
  }

  static modifyTransactionSuccess(card) {
    return {
      type: types.MODIFY_TRANSACTION_SUCCESS,
      payload: {
        card,
      },
    }
  }

  static modifyTransactionFail(error) {
    return {
      type: types.MODIFY_TRANSACTION_FAIL,
      payload: {
        error,
      },
    }
  }

}

function createMPCardToken(number, expiryMonth, expiryYear, cvc, cardholderName) {
  return apiExternal.post(
    'https://api.mercadopago.com/v1/card_tokens?public_key=' + config.MERCADOPAGO_PUBLIC_KEY,
    {
      card_number: number,
      expiration_month: expiryMonth,
      expiration_year: "20" + expiryYear, //TODO change in 100 years, sorry future humans
      security_code: cvc,
      cardholder: {
        name: cardholderName,
      },
    },
  )
    .then(response => {
      return response.data.id
    }, error => {
      throw error
    })
}

function translateType(type) {
  switch (type) {
    case 'mastercard':
      return 'master'
    case 'dinersclub':
      return 'diners'
    default:
      return type
  }
}



// WEBPACK FOOTER //
// ./src/sections/rent/actions/payment.js